/**
 * CSS écrit à la main de la route, injecté par le premier `<style>` de `landing.tsx` : les deux
 * `@font-face`, le thème clair `html{color-scheme:light}`, puis `compositionCss` (`./composition` : format
 * cadré, fenêtres basses, figures dessinées à leur taille d'ordinateur), puis la feuille du mode mobile
 * `mobileCss` (`./mobile`), en fin de chaîne (garde : S8, `styles/mobile.test.ts`). Les autres `styles/*.css` sont extraits
 * mécaniquement, sauf `styles/risques.css`, écrit à la main pour la scène risques
 * (README, « Le CSS » et « CSS : écart à l'extraction mécanique »).
 *
 * Les `@font-face` sont ré-écrits plutôt qu'importés depuis `@fontsource-variable/geist{,-mono}` :
 * le paquet déclare la famille `'Geist Variable'`, alors que `base.css` (extrait, intouchable)
 * attend `'Geist'` (`maquette:69-70`). L'`unicode-range` est copié tel quel depuis le CSS du
 * paquet (`wght.css`, bloc `geist-latin-wght-normal` / `geist-mono-latin-wght-normal`), identique
 * pour les deux polices.
 */
import geistWoff2 from "@fontsource-variable/geist/files/geist-latin-wght-normal.woff2?url";
import geistMonoWoff2 from "@fontsource-variable/geist-mono/files/geist-mono-latin-wght-normal.woff2?url";
import { compositionCss } from "./composition";
import { mobileCss } from "./mobile";

export const authoredCss = `
@font-face {
	font-family: 'Geist';
	font-style: normal;
	font-display: swap;
	font-weight: 100 900;
	src: url(${geistWoff2}) format('woff2-variations');
	unicode-range: U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD;
}
@font-face {
	font-family: 'Geist Mono';
	font-style: normal;
	font-display: swap;
	font-weight: 100 900;
	src: url(${geistMonoWoff2}) format('woff2-variations');
	unicode-range: U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD;
}
html{color-scheme:light}
${compositionCss}
${mobileCss}`;
